import React from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import ChevRight from '../../../svg/shared/ChevRight';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: { SHOW_MORE }
} = StringConstantsMixin;

const ShowMoreCard = ({ url }) => {
  return (
    <div className={styles.container}>
      <a href={url}>
        <div className={styles.showMore}>
          <div>{SHOW_MORE}</div>
          <ChevRight />
        </div>
      </a>
    </div>
  );
};

ShowMoreCard.propTypes = {
  url: string.isRequired
};

export default ShowMoreCard;
